<template>

  <div class="wrapper center-text">
    <h2 class="top-padding">FAQ</h2>
  </div>

  <div class="grid justify-content-center">
    <div class="col-12 md:col-8">

      <Accordion :multiple="false" :activeIndex="[0]">
        <AccordionTab header="What makes Wero Mānuka honey special?">
          <p class="faq-text">Mānuka honey is a truly unique and special product. We have perfected our process to ensure that the highest quality product is derived from this mystical native flower. For hundreds of years, Māori people have woken up to the healing powers of Mānuka honey, using it as a natural remedy for inflammation, skin conditions and infections. Our naturally sweet Mānuka honey is produced by bees that pollinate only one plant - the Manuka bush (Leptospermum scoparium).</p>
          <img :src="properties" class="chart"/>
          <p class="faq-text">Wero honey is pure and natural, created from the healthiest hives in the most pristine environments on Earth. We go to great lengths to ensure that all our honey is independently tested, 100% natural, and created using only sustainable practices.</p>
        </AccordionTab>
        <AccordionTab header="What is MGO?">
          <img :src="methylglyoxal" class="chart" style="max-height: 150px;"/>
          <p class="faq-text">The active ingredient in Mānuka honey is methylglyoxal (MGO). The higher the MGO, the higher the levels of enzymes and antibacterial properties, making it beneficial to those who consume it regularly or use it as a topical treatment on wounds and cuts. As the MGO content increases, so do the medicinal benefits of the honey, and let’s not forget the unmistakable taste and smooth velvety texture that is characteristic to Mānuka honey.</p>
        </AccordionTab>
        <AccordionTab header="Can I convert between MGO and UMF?">
          <p class="faq-text">UMF and MGO are related to each other using a mathematical formula. If the UMF goes up, so does the MGO (Methylglyoxal). Here is our comparison chart to help you understand how the UMF vs MGO numbers work.</p>
          <img :src="chart" class="chart"/>
          <p class="faq-text">It should also be noted that when you get our honey you are actually getting the highest rating of the two. For example, our 800+ jar is also rated at 20+ UMF, so we ensure that the honey within actually contains at least 829 MGO.</p>
        </AccordionTab>
        <AccordionTab header="How do I know the MGO content is accurate?">
          <p class="faq-text">All Mānuka honey for export from New Zealand must be independently tested and pass the Mānuka Honey Science Definition as defined by <a href="https://www.mpi.govt.nz/food-business/honey-bee-products-processing-requirements/manuka-honey-testing/" target="_blank">Ministry for Primary Industries (MPI)</a>. Testing is is made up of a combination of 5 attributes. The honey must pass all five tests to be labeled as Mānuka.</p>
          <p class="faq-text">Additionally, all Wero Mānuka honey undergoes testing by an independent laboratory, straight from the hive and again every 6 months while the honey ages, until the honey is packed into jars.</p>
        </AccordionTab>
        <AccordionTab header="Can children under 12 months old consume honey?">
          <p class="faq-text">Honey is a great natural sweetener and superfood, but it's not recommended for babies under 12 months of age. Honey may contain bacteria that can make young babies sick. Children and adults have more developed digestive systems, which can kill the bacteria.</p>
        </AccordionTab>
      </Accordion>


    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomSection',

  props: {

  },

  mounted() {

  },

  data() {
    return {
      chart: require("../../assets/images/conversion chart.jpg"),
      properties: require("../../assets/images/what is manuka.png"),
      methylglyoxal: require("../../assets/images/methylglyoxal.png"),
    }
  },

  methods: {

  },

  computed: {
    vuex: function(){
      return(this.$store.state);
    },

  },

  watch: {

  }

}

</script>


<style scoped>

.wrapper{
  padding-bottom: 2rem;
}


.info-title{
  font-family: acumin-pro, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 1.4rem;
  text-align: justify;
}
.faq-text{
  font-family: acumin-pro, sans-serif !important;
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 1.4rem;
  text-align: justify;
}

.chart{
  max-width: 100%;
  padding: 1rem 1rem 0rem 1rem;
}
.chart-caption{
  padding: 0;
  margin-top: 0;
}

@media screen and (max-width: 767px){
  .hidden-on-mobile{
    display: none;
  }
}



</style>


